<template>
  <v-overlay :value="overlay" z-index="1000">
    <v-progress-circular indeterminate size="64" />
  </v-overlay>
</template>

<script>
import { handleOAuth } from "../modules/bank-oauth-handler";
import { redirectToOriginSubdomain } from "@/modules/origin-redirect-utils";
export default {
  data: () => ({
    overlay: false,
  }),
  name: "callback",
  async created() {
    this.overlay = true;
    const redirectUrl = await handleOAuth(this.$route.meta.props.to);
    if (redirectUrl.startsWith("https://"))
    {
      window.location.href = redirectUrl
    }
    await redirectToOriginSubdomain();
    await this.$router.push({ path: redirectUrl });
  },
};
</script>
